<template>
  <div class="d-flex">
    <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Filtro de Departamentos</div>

    <v-autocomplete
      :items="listaDeDepartamentos"
      item-text="descricao_departamento"
      item-value="id_departamento"
      multiple
      outlined
      hide-details
      :placeholder="primeiroDepartamentoSelecionado ? '' : 'Nenhum selecionado'"
    >
      <template v-slot:prepend-item>
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="todosSelecionados">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todos os departamentos</span>
          </template>
          <template v-else>
            <v-icon v-if="!departamentosSelecionados.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todos os departamentos</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:item="{item}">
        <v-list-item class="item-list px-3" @click="addOuRemoveItem(item)">
          <v-list-item-icon>
            <v-icon v-if="departamentoSelecionado(item)" color="primary">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n6">
            <v-list-item-title>{{item.id_departamento}} - {{ item.descricao_departamento }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:prepend-inner v-if="departamentosSelecionados.length > 0">
        <v-chip dense class="ma-0 mt-n1">{{ primeiroDepartamentoSelecionado }}</v-chip> 
      </template>

      <template v-slot:append>
        <template v-if="departamentosSelecionados.length > 1">
          <v-chip small outlined color="#666666" style="height: 20px">
            + {{ `${departamentosSelecionados.length} selecionados`}}
          </v-chip>
        </template>
        <template v-else>
          <v-icon>mdi-filter</v-icon>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import mixin from '../MixinDRP'

export default {
  name: "filtroDepartamento",
  model: {
    prop: 'departamentosSelecionados',
    event: 'change-departamento'
  },
  props: {
    departamentosSelecionados: {
      type: Array,
      required: true
    },
    itensFull: {
      type: Array,
      required: false
    }
  },
  mixins: [mixin],
  computed: {
    listaDeDepartamentos () {
      return this.itensFull;
    },
    todosSelecionados () {
      return this.departamentosSelecionados.length > 0 && this.departamentosSelecionados.length === this.listaDeDepartamentos.length;
    },
    primeiroDepartamentoSelecionado () {
      if (this.departamentosSelecionados.length === 0) return 0;

      return this.departamentosSelecionados[0].descricao_departamento;
    }
  },
  methods: {
    departamentoSelecionado (item) {
      const selecionado = this.departamentosSelecionados.filter(dep => dep.id_departamento == item.id_departamento)

      return selecionado.length > 0
    },
    selecionarDepartamentos (ev) {
      this.$emit('change-departamento', ev)
    },
    selecionarTodos () {
      if (this.todosSelecionados) {
        this.selecionarDepartamentos([])
      } else {
        this.selecionarDepartamentos(this.listaDeDepartamentos)
      }
    },
    addOuRemoveItem (item) {
      let novosSelecionados

      if (this.departamentoSelecionado(item)) {
        novosSelecionados = this.departamentosSelecionados.filter(departamento => departamento.id_departamento != item.id_departamento)
      } else {
        novosSelecionados = this.departamentosSelecionados.concat(item)
      }

      this.selecionarDepartamentos(novosSelecionados)
    }
  }
}
</script>

<style scoped>
.item-list {
  cursor: pointer;
}
.item-list:hover {
  background: rgba(0,0,0,.05);
}
.txt-primeiro-selecionado {
  font-size: 13px;
  white-space: nowrap;
}
</style>
